<mat-form-field class="small-field">
  <mat-label>{{ label }}</mat-label>
  <input type="number" matInput [formControl]="scoreControl">
  <button mat-icon-button matSuffix (click)="onOpenCalculatorModal($event)"><i class="fa-regular fa-calculator"></i></button>
</mat-form-field>
